import React from 'react';
import { BrowserRouter } from 'react-router';

export const ResQRouter = ({ children }: { children: React.ReactNode }) => {
    return <BrowserRouter>{children}</BrowserRouter>;
};
